<template>
    <div class="header">
        <el-header>
            <router-link :to="$store.getters.homePage">
                <div class="logo">
                    <img src="../assets/logo.png"/>
                    <span style="transform: translateX(-2.5em);" v-if="!is_mobile">管理后台</span>
                </div>
            </router-link>

            <div class="header-right">
                <span style="font-size: 14px; margin-right: 30px;" v-if="!is_mobile">
                    语音提醒：<el-switch @change="showVoice"
                                    v-model="is_show_voice"
                                    active-color="#ffa000"
                                    inactive-color="#C0C4CC">
                    </el-switch>
                </span>

                <span class="notice-box" @click="showNotice" v-if="!is_mobile">
                    <span class="notice" v-if="is_notice > 0">
                        <el-badge value="●" class="test">
                            <i class="el-icon-bell"></i>
                        </el-badge>
                    </span>
                        <span class="notice" v-else>
                        <i class="el-icon-bell"></i>
                    </span>
                    <span class="notice-text">提醒</span>
                </span>
                <el-avatar :src="logo_avatar" v-if="!is_mobile"></el-avatar>
                <div class="name" >
                    <el-select v-model="value" placeholder="登录" ref="admin">
                        <el-option style="color: #606266;cursor: pointer;"
                                   v-for="item in options"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"
                                   :disabled="item.disabled"
                        ></el-option>
                    </el-select>
                </div>
                <span v-if="env_model === 'production' && !is_mobile"><a :href="download_file" class="download_file"> PC端下载 </a></span>
                <el-dropdown class="download_file download_mobile download_mobile_image" trigger="click" v-if="role_id != 2 && env_model === 'production' && !is_mobile">
                        <el-button type="primary" style="background: none;transform: translateY(-38px);font-size: 14px;color: #ff0;">
                            移动端下载
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-image style="width: 100px;height: 100px;margin: auto 10px;" :src="download_mobile"></el-image>
                        </el-dropdown-menu>
                </el-dropdown>
                <span class="exit" @click="handleExit" v-if="!is_mobile">
                  <img src="../assets/exit_icon.png"/>
                  <span>退出</span>
                </span>
                <span class="exit" @click="handleExit" v-else style="margin-left: 0;">
                  <img src="../assets/exit_icon.png"/>
                  <span>退出</span>
                </span>

            </div>
        </el-header>

        <el-dialog class="headerbar" title="消息提醒" :visible.sync="noticeVisible" @close="dialogClose()">
            <div style="text-align: left;margin-bottom: 10px;">
                <el-button @click="toggleRead()">全部已读</el-button>
                <el-button @click="partRead()">标记已读</el-button>
                <el-button @click="partDelete()">删除</el-button>
                <el-button @click="toggleDelete()">全部删除</el-button>
                <el-button @click="resetNotice">重置</el-button>
                <el-button @click="searchNotice">筛选</el-button>
            </div>
            <el-row class="inputs mg-20" :gutter="20">
                <el-col :md="8" :lg="7" :xl="7">
                    <span class="fs-14 pd-r-10">消息类型：</span>
                    <el-select class="status" v-model="search_type" placeholder="请选择消息类型" style="width: 100%;max-width: none !important;">
                        <el-option
                            v-for="item in msgType"
                            :key="item.id"
                            :label="item.type_name"
                            :value="item.id"
                        v-if="role_id != 2"></el-option>
                        <el-option
                            v-for="item in managerMsgType"
                            :key="item.id"
                            :label="item.type_name"
                            :value="item.id"
                            v-if="role_id == 2"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row class="inputs mg-20" :gutter="20">
                <el-col :md="8" :lg="7" :xl="7">
                    <span class="fs-14 pd-r-10">&ensp;&ensp;关键词：</span>
                    <el-input v-model="search_content" placeholder="消息关键词模糊搜索" style="width: 100%;" />
                </el-col>
                <el-col :md="6" :lg="8" :xl="9">
                    <span class="fs-14 pd-r-10">消息时间：</span>
                    <el-date-picker
                        v-model="search_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <el-table ref="multipleTable" :data="noticeList" tooltip-effect="dark" style="width: 100%"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="25"></el-table-column>
                <el-table-column width="18">
                    <template slot-scope="scope">
                        <span :class="scope.row.is_read == 1 ? 'read': 'unread'">●</span>
                    </template>
                </el-table-column>
                <el-table-column label="消息内容">
                    <template slot-scope="scope">

                        <div @click="goDetail(scope.row)" style="cursor: pointer;">
                            <span>{{ scope.row.title }},</span>
                            <span v-if="scope.row.type == 1 || scope.row.type == 2">预约编号：<i
                                class="user">{{ scope.row.reservation_id }}</i></span>
                            <span v-else-if="scope.row.type == 5">
                                用户类型：<i class="user">{{ scope.row.user_role_txt }}</i>&ensp;
                                姓名：<i class="user">{{ scope.row.user_name }}</i>&ensp;
                                手机号码：<i class="user">{{ scope.row.mobile }}</i>
                            </span>
                            <span v-else>特属专家姓名：<i class="user">{{ scope.row.doctor_name }}</i>&ensp; 特属服务对象姓名：<i
                                class="user">{{ scope.row.user_name }}</i></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="create_date"
                    label="时间"
                    width="160">
                </el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[10,15, 20, 50]" :total="total" :page-size="perpage"
                           :current-page="page"
                           @current-change="serviceChangePage" @size-change="serviceChangeSite"
                           v-if="total >= 10"></el-pagination>
        </el-dialog>

    </div>
</template>
<script>
import {removeToken} from "@/utils/auth";
import {check} from "@/utils/checkData";
import {getUserInfos} from "@/utils/userInfos";
import {isMobile} from "@/api/order";

export default {
    name: "Headerbar",
    inject: ['is_notice_change', 'voice_close', 'voice_open', 'chat_no_reply', 'health_record_log', 'apply_user_detail'],
    data() {
        return {
            env_model: '',
            role_id: 0,
            options: [],
            value: "",
            is_notice: "0",
            noticeVisible: false,
            noticeList: [],
            total: 0,
            perpage: 10,
            page: 1,
            is_watch: false,
            selectNoticeIds: [],
            voiceText: '开启语音提醒',
            is_show_voice: false,
            is_submit: false,
            search_type: '',
            search_content: '',
            msgType: [
                {id: 1, type_name: "创建预约单"},
                {id: 2, type_name: "超时未处理"},
                {id: 3, type_name: "超时未回复"},
                {id: 4, type_name: "健康档案"},
                {id: 5, type_name: "注册申请"},
            ],
            managerMsgType: [
                {id: 1, type_name: "创建预约单"},
                {id: 2, type_name: "超时未处理"},
            ],
            search_date: [],
            start_date: '',
            end_date: '',
            download_file: "https://www.ryiw.vip/frontweb/ryiw-admin.exe",
            download_mobile: require('@/assets/admin_apk.png'),
            is_mobile: false,
            logo_avatar:require('@/assets/logo_avatar.png'),
        };
    },
    created() {
        this.is_mobile = isMobile()
    },
    mounted() {
        this.env_model = process.env.NODE_ENV
        let userInfo = getUserInfos();
        let name = userInfo ? userInfo.user_name : '';
        let role_name = userInfo ? userInfo.role_name : '';
        let role_id = userInfo ? userInfo.role_id : 0;
        this.role_id = role_id
        if (name.length > 15) {
            name = name.substr(0, 12) + "...";
        }
        this.$refs.admin.$el.querySelector("input").value = name;

        if (role_id > 1) {

            let group_name = userInfo ? userInfo.group_name : '';
            let group_mobile = userInfo ? userInfo.group_mobile : '';


            // 服务人员
            if (role_id == 3 && group_name && group_mobile) {
                if (userInfo.child_role_id == 0) {
                    // 组长
                    if (name) {
                        this.options.push({
                            label: `角色：${role_name}-组长`,
                            value: name,
                            disabled: true
                        });
                    }
                } else {
                    if (name) {
                        this.options.push({
                            label: `角色：${role_name}`,
                            value: name,
                            disabled: true
                        });
                    }
                    this.options.push({
                        label: `组长：${group_name}(${group_mobile})`,
                        value: group_mobile,
                        disabled: true
                    });
                }

            } else {

                if (name) {
                    this.options.push({
                        label: `角色：${role_name}`,
                        value: name,
                        disabled: true
                    });
                }

                if (role_id == 2 ) {
                    // 助理
                    let leaderInfo = group_name || '无'
                    if (group_mobile) {
                        leaderInfo = `${leaderInfo}(${group_mobile})`
                    } else {
                        group_mobile = '暂无'
                    }
                    this.options.push({
                        label: `负责人：${leaderInfo}`,
                        value: group_mobile,
                        disabled: true
                    });
                }

            }

        } else {
            if (name) {
                this.options.push({
                    label: role_name,
                    value: name,
                    disabled: true
                });
            }
        }


        this.is_watch = true
        this.getNoticeUnReadCount()
    },

    methods: {
        isMobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        },
        showVoice() {
            if (this.is_show_voice) {
                // 开启语音提醒
                // this.is_show_voice = true
                this.voice_open()
                this.voiceText = '关闭语音提醒'
            } else {
                // 关闭语音提醒
                // this.is_show_voice = false
                this.voice_close()
                this.voiceText = '开启语音提醒';
            }
        },
        // 删除通知消息
        deleteNotice(delete_type) {
            let params = {
                servername: 'Ruyi_AdminHomeServices',
                method: 'deleteNotice',
                params: {
                    delete_type: delete_type,
                    ids: this.selectNoticeIds,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '删除成功',
                    duration: 1500,
                });
                this.is_submit = false;
                this.getNoticeList()
                this.getNoticeUnReadCount()
            }).catch((err) => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 全部删除
        toggleDelete() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;

            this.$confirm('确定要删除所有通知消息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteNotice('del_all');
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 部分删除
        partDelete() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;

            this.$confirm('确定要删除所选通知消息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteNotice('del_part')
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 消息跳转
        goDetail(row) {
            if (row.type == 3) {

                let doctor_id = row.content_params.doctor_id
                let user_id = row.content_params.user_id
                let user_name = row.content_params.user_name
                let doctor_name = row.content_params.doctor_name
                if (this.$route.name !== 'oneChatLogDetail') {
                    this.$router.push({
                        name: "oneChatLogDetail",
                        params: {
                            user_id: doctor_id,
                            obj_id: user_id,
                            friend_name: user_name,
                            own_name: doctor_name,
                        }
                    });
                } else {
                    this.chat_no_reply(doctor_id, user_id, user_name, doctor_name);
                }

            } else if (row.type == 4) {

                let user_name = row.content_params.user_name
                let doctor_name = row.content_params.doctor_name
                if (this.$route.name !== 'healthrecordLogList') {
                    this.$router.push({
                        name: "healthrecordLogList",
                        params: {
                            user_name: user_name,
                            doctor_name: doctor_name,
                        }
                    });
                } else {
                    this.health_record_log(user_name, doctor_name);
                }
            } else if (row.type == 2) {
                this.$router.replace({
                    name: "noResponse",
                    query: {}
                }).catch(err => {
                });
            } else if (row.type == 1) {
                this.$router.replace({
                    name: "workList",
                    query: {}
                }).catch(err => {
                });
            } else if (row.type == 5) {
                let user_name = row.content_params.user_name
                let mobile = row.content_params.mobile
                if (this.$route.name !== 'applyList') {
                    this.$router.push({
                        name: "applyList",
                        params: {
                            user_name: user_name,
                            mobile: mobile,
                        }
                    });
                } else {
                    this.apply_user_detail(user_name, mobile);
                }
            }
            this.noticeVisible = false;
            this.selectNoticeIds = [row.id]
            this.partRead()
            this.getNoticeUnReadCount()
        },
        // 全部标为已读
        toggleRead() {
            let params = {
                servername: 'Ruyi_AdminHomeServices',
                method: 'setNoticeRead',
                params: {
                    read_type: 'read_all',
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.is_notice = "0"
                this.getNoticeList()
                this.getNoticeUnReadCount()
            });
        },
        // 部分标记已读
        partRead() {
            let params = {
                servername: 'Ruyi_AdminHomeServices',
                method: 'setNoticeRead',
                params: {
                    read_type: 'read_part',
                    ids: this.selectNoticeIds,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.getNoticeList()
                this.getNoticeUnReadCount()
            });
        },
        // 选中
        handleSelectionChange(val) {
            this.selectNoticeIds = [];
            let ids = [];
            for (let i = 0; i < val.length; i++) {
                ids.push(val[i].id)
            }
            this.selectNoticeIds = ids
        },
        dialogClose() {
            this.noticeVisible = false;
            this.selectNoticeIds = [];
        },
        showNotice() {
            this.noticeVisible = true;
            this.getNoticeList()
        },
        serviceChangePage(index) {
            this.page = index;
            this.getNoticeList();
        },
        serviceChangeSite(index) {
            this.perpage = index;
            this.getNoticeList();
        },
        handleExit() {
            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'logout'
            }
            this.$api.service(params).then(() => {
                window.localStorage.setItem('is_logout', '1')
                removeToken();
                this.$store.commit("REMOVE_TOKEN");
                this.$router.replace("/login");
            });
            this.$store.dispatch('websocket/close')
            localStorage.setItem('is_refresh', 'false')
        },
        getNoticeUnReadCount() {
            let params = {
                servername: 'Ruyi_AdminHomeServices',
                method: 'getNoticeCount',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data > 0) {
                    this.is_notice = res.data.data;
                } else {
                    this.is_notice = 0;
                }
            });
        },
        resetNotice() {
            this.search_date = []
            this.search_type = ''
            this.search_content = ''
            this.start_date = ''
            this.end_date = ''
            this.page = 1;
            this.getNoticeList()
        },
        searchNotice() {
            if (this.search_date) {
                this.start_date = this.search_date[0];
                this.end_date = this.search_date[1];
            }
            this.page = 1;
            this.getNoticeList()
        },
        getNoticeList() {
            let params = {
                servername: 'Ruyi_AdminHomeServices',
                method: 'getNoticeList',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    search_type: this.search_type,
                    search_content: this.search_content,
                    start_date: this.start_date,
                    end_date: this.end_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let list = res.data.data.list;
                for (let i = 0; i < list.length; i++) {

                    if (list[i].type < 3) {
                        list[i].reservation_id = list[i].content_params.reservation_id;
                    } else if (list[i].type == 5) {
                        list[i].user_name = list[i].content_params.user_name;
                        list[i].user_role_txt = list[i].content_params.user_role == 3 ? '特属专家' : '特属服务对象';
                        list[i].mobile = list[i].content_params.mobile;
                    } else {

                        list[i].doctor_name = list[i].content_params.doctor_name;
                        list[i].user_name = list[i].content_params.user_name;
                    }
                }

                this.noticeList = list;
                this.total = res.data.data.page.count;
            });
        },
    },
    watch: {
        is_notice_change: {
            immediate: true,
            deep: true,
            handler(nVal) {
                process.env.NODE_ENV !== 'production' && console.log(nVal)
                if (this.is_watch) {
                    this.getNoticeUnReadCount()
                }
            },
        }
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.header {
    .clearfix::after {
        content: "";
        display: block;
        clear: both;
    }

    .logo {
        height: 50px;
        margin-top: 5px;
        float: left;

        & > img {
            width: auto;
            height: 100%;
        }

        & > span {
            vertical-align: top;
            display: inline-block;
            height: 100%;
            width: 180px;
            color: white;
            line-height: 50px;
            font-weight: bolder;
        }
    }

    .header-right {
        float: right;
        height: 100%;

        & span {
            line-height: 60px;
            display: inline-block;
            vertical-align: top;
            color: white;
        }

        & .el-avatar {
            margin-top: 10px;
        }

    }

    .el-header {
        background: $dominantHue;
    }

    .name {
        margin: 10px 10px 0 10px;
        display: inline-block;

        .el-select {
            width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 40px !important;

            .el-input__icon {
                vertical-align: top;
            }

            .el-input {
                input {
                    background: $dominantHue;
                    color: white;
                    border: 0;
                }
            }
        }
    }

    .exit {
        display: inline-block;
        height: 50px;
        margin-left: 20px;
        cursor: pointer;

        & > img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
        }

        & > span {
            font-size: 14px;
            padding-left: 5px;
            vertical-align: middle;
        }
    }

    .voice-box {
        margin-right: 30px;
        font-size: 14px;

    }

    .notice-box {
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        margin-top: 10px;
        border: 1px solid #6b99f0;

        margin-right: 30px;
        cursor: pointer;
        .notice-text {
            font-size: 14px;
            transform: translate(-8px, -11px);
        }

        .notice {
            transform: translate(2px, -11px);
            display: inline-block;
            height: 50px;
            margin-right: 20px;

            i {
                font-size: 20px;
                padding-left: 5px;
                vertical-align: middle;
            }

            .el-badge__content.is-fixed {
                right: 12px;

            }
        }
    }

    .notice-box:hover {
        border: 1px solid #5089f5;
        box-shadow: 0 0 15px #5089f5;
    }

    .user {
        font-style: normal;
        color: #f56c6c;
    }

    .unread {
        color: #f56c6c;
    }

    .read {
        color: #c0ccda;
    }

    .el-table-column--selection .cell {
        width: 35px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .el-table_1_column_2 {
        width: 20px;

        div.cell {
            padding-right: 0;
        }
    }

    .inputs .el-select.status .el-input {
        width: 100%;
    }
}
.headerbar .el-dialog {
    min-width: 920px;
    margin-top: 5vh !important;
}
.download_file{
    //text-decoration-line: none;
    font-size: 14px;
    color: #ff0;
    margin-right:15px;
    margin-left: 15px;
    font-weight: bold;
}
.download_mobile.download_mobile_image {
    top: 0;
    button{
        display: inline-block !important;
        //background: none !important;
        font-size: 14px;
        color: #ff0;
        border:none;
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: #ff0;
        padding-right: 0;
        padding-left: 0;
        span{
            color: #ff0 !important;
            text-decoration: underline;
            text-decoration-color: #ff0;
        }
    }

}
.el-dropdown-menu.el-popper{
    transform: translateY(-70px);
}
</style>


